import domReady from "@wordpress/dom-ready";

const initAnimation = (section) => {
	const items = section.querySelectorAll(".gallery__item");

	items?.forEach((item) => {
		const thisTranslateY = parseInt(item.getAttribute("data-translateY"));
		window.customScrollbarInstance?.parallaxController?.createElement({
			el: item,
			props: {
				targetElement: section,
				translateY: [thisTranslateY, thisTranslateY * -1],
			},
		});
	});
};

domReady(() => {
	// console.log("GALLERY DOM READY");

	const allGallerySections = document.querySelectorAll(
		".wp-block-theme-blocks-gallery",
	);

	allGallerySections?.forEach((section) => {
		initAnimation(section);
	});
});
